var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrum55(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8772 3.18859C15.6245 3.18859 18.6623 2.58378 18.6623 1.83772C18.6623 1.09165 15.6245 0.486837 11.8772 0.486837C8.12989 0.486837 5.0921 1.09165 5.0921 1.83772C5.0921 2.58378 8.12989 3.18859 11.8772 3.18859Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42982 7.70175C5.42982 8.48465 8.33114 9.12938 11.9079 9.12938C15.4846 9.12938 18.386 8.5 18.386 7.70175"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2939 2.23684C18.3246 3.89473 18.3553 5.78289 18.3706 7.80921"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44518 7.82456C5.46053 5.78289 5.49123 3.89473 5.52193 2.23684"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42982 7.70175L5 8.40789C5 9.19079 8.08553 9.83552 11.9079 9.83552C15.7303 9.83552 18.8158 9.20614 18.8158 8.40789L18.386 7.70175"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52193 14.7325C5.52193 15.5614 8.42324 16.2368 12 16.2368C15.5768 16.2368 18.4781 15.5614 18.4781 14.7325"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.386 8.97588C18.4167 10.7259 18.4474 12.7215 18.4627 14.8553"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53728 14.8553C5.55263 12.7061 5.58333 10.7105 5.61403 8.96053"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61404 22.0088C5.61404 22.8377 8.51536 23.5132 12.0921 23.5132C15.6689 23.5132 18.5702 22.8377 18.5702 22.0088"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4781 16.2522C18.5088 18.0022 18.5395 19.9978 18.5548 22.1316"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62938 22.1316C5.64473 19.9825 5.67543 17.9868 5.70613 16.2368"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52192 14.7325L5.1842 15.5307C5.1842 16.3136 8.26973 16.9583 12.0921 16.9583C15.9145 16.9583 19 16.3289 19 15.5307L18.4781 14.7325"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrum55);
export default __webpack_public_path__ + "static/media/Drum55.439d6311e1ce1db68b58bb99c61478f1.svg";
export { ForwardRef as ReactComponent };